import { CompanyHierarchyNode } from "src/api/client-api/company/useOrganizationHierarchy";

export type CompanyTreeNode = {
    company: CompanyHierarchyNode;
    treeItemId: string;
    children: CompanyTreeNode[];
};

export const normalizeCompanyHierarchy = (nodes: CompanyHierarchyNode[] | undefined): CompanyHierarchyNode[] => {
    if (!nodes || nodes.length === 0) {
        return [];
    }

    const dedupedNodes: CompanyHierarchyNode[] = [];
    const indexById = new Map<number, number>();

    for (const node of nodes) {
        const normalizedChildren = normalizeCompanyHierarchy(node.children);
        const normalizedNode: CompanyHierarchyNode = {
            ...node,
            children: normalizedChildren,
        };

        const existingIndex = indexById.get(node.id);
        if (existingIndex === undefined) {
            dedupedNodes.push(normalizedNode);
            indexById.set(node.id, dedupedNodes.length - 1);
            continue;
        }

        const existingNode = dedupedNodes[existingIndex];
        const mergedChildren = normalizeCompanyHierarchy([
            ...(existingNode.children ?? []),
            ...(normalizedNode.children ?? []),
        ]);

        dedupedNodes[existingIndex] = {
            ...existingNode,
            children: mergedChildren,
        };
    }

    return dedupedNodes;
};

export const buildCompanyTreeNodes = (nodes: CompanyHierarchyNode[], parentPath = "root"): CompanyTreeNode[] => {
    return nodes.map((node, index) => {
        const treeItemId = `${parentPath}-${node.id}-${index}`;

        return {
            company: node,
            treeItemId,
            children: node.children && node.children.length > 0 ? buildCompanyTreeNodes(node.children, treeItemId) : [],
        };
    });
};
